export const extractDocumentText = (t: string): string => {
  const s = String(t || '');
  const docRegex = /<DOCUMENT>([\s\S]*?)<\/DOCUMENT>/i;
  const m = docRegex.exec(s);
  const maybeDoc = m?.[1]?.trim();
  if (maybeDoc) return maybeDoc;
  const structuredRegex = /<STRUCTURED>[\s\S]*?<\/STRUCTURED>/gi;
  const cleaned = s.replaceAll(structuredRegex, '').trim();
  return cleaned;
};
